import apiClient from './client';

export const registerClinic = async (payload) => {
  const response = await apiClient.post('/signup', payload, {
    timeout: 60000 // 60 seconds for clinic provisioning
  });
  return response.data;
};